import React, { useEffect, useState } from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import './style.scss';
import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { getOrConvertToPst } from '../../utils/timezone';
import schema from './schema';
import Validator from '../../components/Validator';
import Input from '../../components/Form/Input';
import Button from '../../components/Button';
import { addLusaHeaderParam, parseUrlParams } from '../../utils/parseUrlParams';
import Progress from '../../components/Progress';
import { newNextAction } from '../../actions/navigation';
import infoIcon from '../../assets/images/icon-info.svg';
import Header from '../../components/Header';
import ApplicationId from '../../components/ApplicationId';
import Modal from '../../components/Modal';

const PickPaymentDate = (props) => {
  const { checkinData, validator: { setValues, values, errors, validate, onChangeHandler }, navigate } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(false);
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
  const params = parseUrlParams(window.location.search);

  useEffect(() => {
    const sourceData = get(checkinData, ['data', 'data']) || get(checkinData, ['state', 'data']);
    if (!sourceData) {
      setTimeout(() => navigate(addLusaHeaderParam(`/${workflowType === 'dtm-luwa' ? 'luwa' : workflowType}/results/continue/?key=${params.key}`)), 0);
    } else {
      setValues({
        ...values,
        firstPaymentDate: getOrConvertToPst().add(37, 'd'),
      });
    }
  }, []);

  const toggleModal = () => {
    setIsModal(!isModal);
  };

  const handleDateChange = (date) => {
    onChangeHandler('firstPaymentDate', date);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { dispatch } = props;
    if (schema && validate(schema).isValid) {
      setIsLoading(true);
      dispatch(newNextAction({
        key: params.key,
        workflowType,
        data: {
          test: params.test,
          FirstPaymentDate: moment(values.firstPaymentDate).format('MM-DD-YYYY'),
        },
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        success: (response) => {
          const routeUrl = get(response, 'data.url');
          navigate(routeUrl);
          setIsLoading(false);
        },
        fail: (error) => {
          setIsLoading(false);
          console.log(error);
        },
      }));
    } else {
      setIsLoading(false);
    }
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      <div className="heading-div bg-white">
        <h2>PLEASE SELECT NEW PAYMENT DATE</h2>
        <div className="info-wrapper">
          <h4>
            The payment date you have previously selected
            {' '}
            {get(checkinData, 'data.data.firstPaymentDate') ? getOrConvertToPst(get(checkinData, 'data.data.firstPaymentDate')).format('L') : ''}
            {' '}
            is no longer available.
            <img
              src={infoIcon}
              alt="info icon"
              width={18}
              onClick={toggleModal}
            />
          </h4>
        </div>
        <div className="bg-light datePicker-wrapper">
          <h4>Choose First Payment Date</h4>
          <p>Select a payment date which matches your payroll date.</p>
          <Datetime
            name="firstPaymentDate"
            label="First Payment Date"
            className="dateWrapper"
            value={values.firstPaymentDate}
            defaultValue={Datetime.moment().add(37, 'd')}
            onChange={handleDateChange}
            closeOnSelect
            dateFormat="MM/DD/YYYY"
            timeFormat={false}
            displayTimeZone="America/Los_Angeles"
            isValidDate={(current) => (
              current.isAfter(Datetime.moment().add(36, 'd'))
              && current.isBefore(Datetime.moment().add(47, 'd'))
            )}
            placeHolder="MM/DD/YYYY"
            renderInput={(renderProps) => (
              <Input
                isMasked={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                isRequired
                openCalendar={() => { }}
                hasError={!!errors.firstPaymentDate}
                errorMessage={errors.firstPaymentDate}
                label="First Payment Date"
                placeHolder="MM/DD/YYYY"
                {...renderProps}
              />
            )}
          />
        </div>
        <div className="confirm-btn">
          <Button
            className="btn btn-primary"
            type="button"
            onClick={handleSubmit}
            isLoading={isLoading}
            title={!isLoading && 'CONFIRM'}
          />
        </div>
      </div>
      {isModal && (
      <Modal toggle={toggleModal}>
        <div className="card-header">
          <button type="button" className="close" onClick={toggleModal} aria-label="Confirm" />
          <h5>Why do I have to change my payment date?</h5>
        </div>
        <div className="card-content error-modal">
          <p className="noautopay-modal-subtitle">
            There must be at least
            {' '}
            {get(checkinData, 'data.data.days')}
            {' '}
            days between funding and the first payment date.
            <br />
            You will be able to adjust your first payment date by calling our servicing team after your loan has been funded. (needs to be rephrased)
          </p>
        </div>
      </Modal>
      )}
      {
        isLoading && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

PickPaymentDate.propTypes = {
  validator: PropTypes.object.isRequired,
  navigate: PropTypes.object.isRequired,
  nextAction: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default Validator(schema)(connect(mapStateToProps)(PickPaymentDate));
